import React, { useContext } from 'react';
import { useQuery } from 'react-query';
import { Button, Loading } from '@wfp/ui';
import { iconCopy } from '@wfp/icons';

import { getOpUpdates } from '../../restapi/document';
import { type Country, type OpUpdate } from '../../restapi/types';
import { formatDate } from '../../utils';
import { opUpdatesContext } from './OperationalUpdatesStateProvider';

import './OpUpdatesCountry.scss';


interface Props {
	country: Country
}

export function richTextForUpdate(update: OpUpdate) {
	// title
	const p = document.createElement('p');
	const b = p.appendChild(document.createElement('b'));
	b.appendChild(document.createTextNode(update.title));
	let updateRichText = p.outerHTML;

	// description (multiple paragraphs)
	const lines = update.description.split('\n');
	for (let i = 0; i < lines.length; i++) {
		const l = lines[i];
		const lp = document.createElement('p');
		lp.appendChild(document.createTextNode(l));
		updateRichText += '\n' + lp.outerHTML;
	}

	return updateRichText;
}

export function OpUpdatesCountry({country}: Props) {
	const query = useQuery(['section', country.pk], () => getOpUpdates(country.pk));
	const state = useContext(opUpdatesContext).state;
	const copyToContent = state.copyToContent;

	return (
		<div className="op-updates-country">
			<h6 className="color-primary">{country.name}</h6>
			{query.data ?
				query.data.length ?
					query.data.map((u, i) =>
						<div key={i}>
							<p className="update-date"><i>{formatDate(u.date, true)}</i></p>
							<p className="update-title"><b>{u.title}</b></p>
							<p className="update-description">{u.description}</p>
							<p className="update-button">
								<Button kind="secondary" small
										icon={iconCopy} iconDescription=" " iconReverse
										onClick={() => copyToContent(u)}>
									Copy to content
								</Button>
							</p>
						</div>,
					) : <p>No recent update available for this country.</p>
				: <Loading withOverlay={false} active small/>
			}
		</div>
	);
}